import React from 'react';
import { object, array, func } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import TabContent from '../TabContent';
import CustomOrderTab from '../CustomOrderTab';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { getPackageTypeById, hasRecommendedPackage, isRecommendedPackage } from '../../../utils/packagesUtils';
import { shouldRenderCustomOrder } from '../../../utils/customOrder';
import isInCustomOrderPackageTest from '../../../utils/experiments/customOrderPackage';
import { UPPER_PACKAGES, customOrderPackage } from './config';
import { calcDefaultCheckedId, reportTabClickEvent } from './utils';

import './style.scss';

const TriplePackage = ({
    packageList,
    onComparePackagesClick,
    customOrder
}, { requestContext, general, biEvents }) => {
    const { ab_tests: abTests, current_user: currentUser } = requestContext;
    const tabList = [...packageList];

    const inCustomOrderPackageTest = isInCustomOrderPackageTest(abTests);
    const shouldRenderCustomOrderTab = inCustomOrderPackageTest && shouldRenderCustomOrder({
        customOrder,
        general,
        currentUser,
        inCustomOrderPackageTest
    });

    if (shouldRenderCustomOrderTab) {
        tabList.push(customOrderPackage);
    }

    const defaultCheckedId = calcDefaultCheckedId(packageList);
    const { responseTime } = customOrder;
    const className = classnames('packages-tabs', 'triple', {
        'recommended': hasRecommendedPackage(packageList),
        'show-4-tabs': shouldRenderCustomOrderTab
    });

    return (
        <div className={className}>
            {tabList.map(({ id }) => (
                <input key={id} id={`package-tab-${id}`} name="package-tab-group"
                    type="radio" defaultChecked={defaultCheckedId === id}/>
            ))}

            <div className="nav-container">
                {tabList.map(({ id }) => (
                    <label key={id} htmlFor={`package-tab-${id}`}
                        onClick={() => reportTabClickEvent(biEvents, id)}>
                        <I18n k={getPackageTypeById(id)}/>
                    </label>
                ))}
            </div>

            <div className="tabs-content">
                {packageList.map((packageData) => {
                    const { id } = packageData;
                    const className = classnames('content', { 'recommended': isRecommendedPackage(packageData) });

                    return (
                        <CheckoutFormHOC key={id} className={className} selectedPackageId={id} source={UPPER_PACKAGES}>
                            <TabContent id={id} onComparePackagesClick={onComparePackagesClick}/>
                        </CheckoutFormHOC>
                    );
                })}

                {shouldRenderCustomOrderTab && <CustomOrderTab responseTime={responseTime}/>}
            </div>
        </div>
    );
};

TriplePackage.propTypes = {
    packageList: array,
    onComparePackagesClick: func,
    customOrder: object
};

TriplePackage.contextTypes = {
    requestContext: object,
    general: object,
    biEvents: object
};

const mapStateToProps = ({ packages }, { onComparePackagesClick }) => ({
    packageList: packages.packageList,
    onComparePackagesClick
});

export { TriplePackage };
export default connect(mapStateToProps)(TriplePackage);
